export default "__VITE_ASSET__73bd134d__"